import { store } from '../redux/store';

export const getToken = () => {
  const state = store.getState();
  const token = state?.login?.tokens?.accessToken;
  return token || null;
};
